import * as React from 'react';
import { toast } from 'react-toastify';
import DriverJobsSiteDeparturePlanChangesData from './DriverJobsSiteDeparturePlanChanges';
import type { PartCompleteJob } from './models/DriverJobInterfaces';
import { useState } from 'react';

interface DriverJobsSiteDeparturePartProps {
    partCompleteJob: PartCompleteJob;
    back(): void;
    updatePlanChangesNumber(fieldName: string, fieldValue: number): void;
    updatePlanChangesText(fieldName: string, fieldValue: string): void;
    updatePlan(planFile: File): void;
    next(): void;
}

const DriverJobsSiteDeparturePartData = (props: DriverJobsSiteDeparturePartProps) => {
    const [errors, setErrors] = useState<{ [key: string]: string }>({});
        
    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    

    const back = (e: any) => {
        e.preventDefault();

        props.back();
    }

    const clearError = (errorItem: string) => {
        let errorList = errors;
        delete errorList[errorItem];

        setErrors(errorList);
    }

    const updateNumber = (fieldName: string, fieldValue: number) => {
        clearError(fieldName);
        props.updatePlanChangesNumber(fieldName, fieldValue);
    }

    const updateText = (fieldName: string, fieldValue: string) => {
        clearError(fieldName);
        props.updatePlanChangesText(fieldName, fieldValue);
    }

    const updatePlan = (planFile: File) => {
        clearError("plan");
        props.updatePlan(planFile);
    }

    const validate = () => {
        //check if all jobs are pickup
        var totalItems = props.partCompleteJob.jobItems.length;
        var pickupItems = props.partCompleteJob.jobItems.filter(j => j.typeId === 2).length;
        var isPickup = totalItems === pickupItems;
        let errorList: any = {};
        let formIsValid = true;

        if (isPickup) {
            props.updatePlanChangesNumber("planChanges", 0);
        } else {
            var planChanges = props.partCompleteJob.planChanges.planChanges * 1;
            if (planChanges < 0) {
                formIsValid = false;
                errorList["planChanges"] = "Plan Changes is required";
            } else if (planChanges === 1) {
                if (props.partCompleteJob.planChanges.plan.size === 0) {
                    formIsValid = false;
                    errorList["plan"] = "You must upload a photo of the plan changes";
                }
                if (!props.partCompleteJob.planChanges.planComments) {
                    formIsValid = false;
                    errorList["planComments"] = "Plan Comments are required";
                }
            }
        }

        setErrors(errorList);
        return formIsValid;
    }

    const next = (e: any) => {
        e.preventDefault();
        if (validate()) {
            props.next();
        } else {
            toast.error("Please fix validation errors!");
        }
    }

    var totalItems = props.partCompleteJob.jobItems.length;
    var pickupItems = props.partCompleteJob.jobItems.filter(j => j.typeId === 2).length;
    var isPickup = totalItems === pickupItems;
    let planChangesQuestions = <DriverJobsSiteDeparturePlanChangesData planChanges={props.partCompleteJob.planChanges} isPickup={isPickup} errors={errors} updateNumber={updateNumber} updateText={updateText} updatePlan={updatePlan} />

    return (
        <div>
            <div className="mobileFont marginTop10 marginBottom10">
                <div className="makeitflexspacebetween marginBottom10">
                    <h2 className="mobile-margin">Job Partially Complete</h2>
                    <i className="mobile-icon-grey fas fa-arrow-alt-circle-left mobileMenuSize" onClick={(e) => back(e)}></i>
                </div>
                {planChangesQuestions }
                    
                <div className="defaultbutton__container--right marginTop10">
                    <i className="mobile-icon-green fas fa-arrow-alt-circle-right mobileMenuSize" onClick={(e) => next(e)}></i>
                </div>
            </div>
        </div>
    );
}

export default DriverJobsSiteDeparturePartData;